module.exports = __webpack_public_path__ + "static/media/rocket-illustration.677eea4a.svg";